export default "__VITE_ASSET__D6E8JF2m__"